<template>
  <div v-if="selectedCar" class="px-16 pt-8">
    <base-details-header :el="selectedCar" :structure="headerStructure" />
    <base-subpage-bar :headers="headers" />
  </div>
  <router-view />
</template>

<script>
  import { computed, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { useStore } from 'vuex';
  export default {
    setup() {
      //  INIT
      const store = useStore();
      const route = useRoute();
      //  ASSIGN ELEMENTS
      const selectedElID = { id: route.params.id };
      const selectedDevice = { device: route.params.id };
      onMounted(() => {
        store.dispatch('getManagers');
        store.dispatch('setSelectedCar', selectedElID);
        store.dispatch('getCarTypes');
        store.dispatch('getRentals', {
          ...selectedDevice,
        });
        store.dispatch('getZoneGroups');
      });
      const selectedCar = computed(() => {
        return store.getters.selectedCar;
      });
      //  CREATE OBJ FOR DETAILS HEADER
      const headers = [
        {
          text: 'Generali',
          name: 'menu.sharing.carGenerals',
        },
        {
          text: 'Noleggi associati',
          name: 'menu.sharing.carRentals',
        },
      ];
      const headerStructure = {
        title: [
          {
            title: 'plate',
          },
          {
            class: 'text-sm font-normal text-gray-700',
            placeholder: 'Livello batteria: ',
            title: 'battery_level',
            footer: '%',
          },
        ],
        data: [
          {
            title: 'Prezzo giornaliero ',
            name: 'price_per_day',
            footer: ' €',
          },
          {
            title: 'Prezzo al minuto ',
            name: 'price_per_minute',
            footer: ' €',
          },
          {
            title: 'Prezzo 1-3h ',
            name: 'price_1_3',
            footer: ' €',
          },
          {
            title: 'Prezzo 3-6h ',
            name: 'price_3_6',
            footer: ' €',
          },
          {
            title: 'Prezzo al km ',
            name: 'price_per_km',
            footer: ' €',
          },
          {
            title: 'Posizione ',
            placeholder: 'lat',
            name: 'lng',
            separator: ', ',
          },
        ],
      };
      return {
        selectedCar,
        headers,
        headerStructure,
      };
    },
  };
</script>
<style></style>
